"use strict";

import { browserHistory } from 'react-router';

var AuthenticationAction = require("../../action/authenticationAction");
var AccountStore = require("../../store/accountStore"),
  AuthenticationStore = require("../../store/authenticationStore");

var BaseRouteWrapper = require('../../routes/baseRouteWrapper');
var RouterUtility = require('../../utils/routerUtility');
var AuthType = require('../../constants/auth/authType');

/**
 * Logout View controller
 */

var LogoutPage = React.createClass({

  contextTypes: {
    router: React.PropTypes.object
  },

  componentWillMount: function () {
    AuthenticationStore.addChangeListener(this._onAuthenticationChange);

    if (!AuthenticationStore.isLoggedIn()) {
      return;
    }

    var isActAsLogout = this._checkIsActAsLogout();
    if (isActAsLogout) {
      AuthenticationAction.logoutActAs();
    }
    else {
      var isActAsMode = AccountStore.isActAsMode();
      AuthenticationAction.logout(isActAsMode);
    }
  },

  componentWillUnmount: function () {
    AuthenticationStore.removeChangeListener(this._onAuthenticationChange);
  },

  componentDidMount() {
    if (!AuthenticationStore.isLoggedIn()) {
      this.context.router.replace(BaseRouteWrapper.getLogin());
    }
  },

  _onAuthenticationChange: function () {
    this.context.router.replace(BaseRouteWrapper.getLogin());
  },


  render: function () {
    return (
      <section/>
    );
  },

  _checkIsActAsLogout: function () {
    var type = RouterUtility.getTypeParameter();
    var isActAsLogout = (!!type && type === AuthType.TYPE_ACT_AS);
    return isActAsLogout;
  }
});

module.exports = LogoutPage;
